import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://www.dreambigentertainment.co.uk";
const DEFAULT_IMAGE = "/dream-big-social.png";

function upsert(selector, attribute, value) {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    const match = selector.match(/\[(name|property)="(.+?)"\]/);
    if (match) element.setAttribute(match[1], match[2]);
    document.head.appendChild(element);
  }
  element.setAttribute(attribute, value);
}

export function Seo({ title, description, image = DEFAULT_IMAGE }) {
  const { pathname } = useLocation();
  useEffect(() => {
    const imageUrl = image.startsWith("http") ? image : SITE_URL + image;
    document.title = title;
    upsert('meta[name="description"]', "content", description);
    upsert('meta[property="og:type"]', "content", "website");
    upsert('meta[property="og:title"]', "content", title);
    upsert('meta[property="og:description"]', "content", description);
    upsert('meta[property="og:url"]', "content", SITE_URL + pathname);
    upsert('meta[property="og:image"]', "content", imageUrl);
    upsert('meta[name="twitter:card"]', "content", "summary_large_image");
    upsert('meta[name="twitter:title"]', "content", title);
    upsert('meta[name="twitter:description"]', "content", description);
    upsert('meta[name="twitter:image"]', "content", imageUrl);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", SITE_URL + pathname);
  }, [title, description, image, pathname]);
  useEffect(() => {
    const old = document.getElementById("studio-schema"); if (old) old.remove();
    let data;
    if (pathname === "/") data = {"@context":"https://schema.org","@type":"Organization",name:"Dream Big Entertainment Ltd",url:SITE_URL,email:"contact@dreambigentertainment.co.uk"};
    if (pathname === "/colour-cubes") data = {"@context":"https://schema.org","@type":"MobileApplication",name:"Colour Cubes",applicationCategory:"GameApplication",operatingSystem:"iOS, Android",url:SITE_URL+pathname,image:SITE_URL+"/colour-cubes/icon.webp",publisher:{"@type":"Organization",name:"Dream Big Entertainment Ltd"}};
    if (data) {const script=document.createElement("script");script.id="studio-schema";script.type="application/ld+json";script.textContent=JSON.stringify(data);document.head.appendChild(script);}
    return ()=>document.getElementById("studio-schema")?.remove();
  }, [pathname]);
  return null;
}
